/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const BookmarkIcon = ({ width = 24, height = 24, hidden = false, title = 'Bookmark' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M15.071 34.724 13 31.373l-2.071 3.351a.5.5 0 0 1-.929-.257V24h6v10.467a.5.5 0 0 1-.929.257Z"
    />
    <path
      d="M8 27.443A3.987 3.987 0 0 1 9.995 20h10.523a1 1 0 0 0 .8-.4l11.1-14.8a.5.5 0 0 0-.4-.8H16.025a1 1 0 0 0-.8.4L3.522 19.328h.008A7.942 7.942 0 0 0 8 31.716ZM32.018 16h-3.236l-9 12H18v4h2.518a1 1 0 0 0 .8-.4l11.1-14.8a.5.5 0 0 0-.4-.8Z"
    />
  </svg>`;
};
